import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numericalAbbreviation'
})
export class NumericalAbbreviationPipe implements PipeTransform {

  transform(value: string | number) {
    if (value === null || value === undefined || isNaN(+value)) return '';

    const absValue = Math.abs(+value);
    let result: number;
    let suffix: string | null = null;

    if (absValue >= 1_000_000_000) {
      result = +value / 1_000_000_000;
      suffix = 'B';
    } else if (absValue >= 1_000_000) {
      result = +value / 1000000;
      suffix = 'M';
    } else if (absValue >= 1_000) {
      result = +value / 1_000;
      suffix = 'K';
    } else {
      result = +value;
    }

    return parseFloat(result.toFixed(2)) + (suffix ?? '');
  }
}
